<div class="md:px-10 md:py-4 px-4 overflow-x-hidden ">  
  <div class="overflow-x-auto">
    <router-outlet></router-outlet>
  </div>
</div>
